import React from "react";
import { Calendar,Toast } from 'antd-mobile';
import "./productSale.scss"
import {productSortGetlist,reqProductsales} from "../../api/index"
import SelectDiv from '../../components/selectDiv/selectDiv'
import Buttons  from '../../components/buttons/button'
import {getDay,getMonthStartDateAndDateRange,getWeekStartDateAndEndDateRange,_dateFormatMySelf} from '../../utils/index'
import {MyTable,MyTableHead,MyTableTr,MyTableTh,MyTableTd,MyTableBody} from '../../components/table/index'
export default class ProductSale extends React.Component{
    constructor(props){
        super(props);
        this.state={
            btnval:'num',
            firstId:'',
            secondId:'',
            listData:[],
            secondCateList:[],
            firstCateList:[],
            timeShow:false,
            time:[_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0]),_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])],
            timeText:`${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0])}至${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])}`,
            dateValue:2,
            DateArray:[{
                value:1,
                name:"今日"
            },{
                value:2,
                name:"本周"
            },{
                value:3,
                name:"本月"
            }]
        }
        
    }
    
    changeType(val){
        if(val.value==1){
            this.setState({
                time:[_dateFormatMySelf(new Date()),_dateFormatMySelf(new Date())],
                timeText:`${_dateFormatMySelf(new Date())}至${_dateFormatMySelf(new Date())}`
            })
        }else if(val.value==2){
            this.setState({
                time:[_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0]),_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])],
                timeText:`${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0])}至${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])}`
            })
        }else if(val.value==3){
            this.setState({
                time:[_dateFormatMySelf(getMonthStartDateAndDateRange()[0]),_dateFormatMySelf(getMonthStartDateAndDateRange()[1])],
                timeText:`${_dateFormatMySelf(getMonthStartDateAndDateRange()[0])}至${_dateFormatMySelf(getMonthStartDateAndDateRange()[1])}`
            })
        }
        
        this.setState({
            dateValue:val.value
        },()=>{
            this.getProductsales();
        })
    }
    openTime(){
        console.log("this........",this)
        this.setState({
            timeShow:true
        })
    }
    onConfirm(startDate,endDate){
        this.setState({
            timeShow:false,
            time:[_dateFormatMySelf(startDate),_dateFormatMySelf(endDate)],
            timeText:`${_dateFormatMySelf(startDate)}至${_dateFormatMySelf(endDate)}`
        })
    }
    onCanceltime(){
        this.setState({
            timeShow:false
        })
    }
    selectOneLevel(s){
        this.setState({
            firstId:s.pId
        },()=>{
            this.getCateList(s.pId);
            this.getProductsales();
        })
        
    }
    selectTwoLevel(s){
        this.setState({
            secondId:s.id
        },()=>{
            this.getProductsales();
        })
        
    }
    //获取一级产品分类列表
    async getCateList(id) {
        await productSortGetlist(id).then(res => {
            if (res.code === 0) {
                if (id) {
                    this.setState({
                        secondCateList:res.data
                    },)
                    
                } else {
                    this.setState({
                        firstCateList:res.data
                    },()=>{
                        console.log("this.state.firstCateList..",this.state.firstCateList)
                    })
                   
                }
            } else{
                Toast.fail(res.msg,3)
            }
        });
    }
    getProductsales() {
        Toast.loading("加载中...",5000)
        let obj={
            categoryPid: this.state.firstId,
            categoryId: this.state.secondId,
            ids:'',
            beginAt: this.state.time[0]||"",
            endAt: this.state.time[1]||""
        }
        reqProductsales(obj).then(res => {
            if (res.code == 0) {
                Toast.hide()
                if(this.state.btnval=='num'){
                    let newdata=res.data.data.sort((a,b)=>{
                        return b.skuQuantity-a.skuQuantity
                    })
                    this.setState({
                        listData:newdata
                    })
                }else if(this.state.btnval=='account'){
                    let newdata=res.data.data.sort((a,b)=>{
                        return b.skuMoney-a.skuMoney
                    })
                    this.setState({
                        listData:newdata
                    })
                }
                
                
                
            }else{
                Toast.fail(res.msg,3)
                Toast.hide()
            }
        }).catch(res => {
            
        })
    }
    onlevelClear(){
        this.setState({
            firstId:'',
            secondCateList:[],
            secondId:''
        })
        this.clear.clear();
    }
    twolevelClear(){

    }
    btnBack(val){
        console.log(val)
        this.setState({
            btnval:val
        },()=>{
            this.getProductsales()
        })
    }
    render(){
        const now = new Date();
        let btns=[
            {
                name:"销量",
                val:"num"
            },
            {
                name:"销售额",
                val:"account"
            }
        ]
        return(
            <div className="ProductSale">
                <div className="topWrap">
                    <p>产品分类</p>
                    <div className="productClass">
                            <SelectDiv label={'pName'} value={'pId'}  model={this.state.firstId}  placeholder={"请选择一级分类"} style={{flex:1,marginRight:'12px'}} data={this.state.firstCateList}  changeType={this.selectOneLevel.bind(this)} clear={this.onlevelClear.bind(this)}/>
                            <SelectDiv label={'name'} value={'id'}  model={this.state.secondId}  placeholder={"请选择二级分类"} style={{flex:1}} data={this.state.secondCateList}  changeType={this.selectTwoLevel.bind(this)}  onRef={(ref)=>{this.clear=ref}}  clear={this.twolevelClear.bind(this)}/>
                    </div>
                    <p>时间</p>
                    <div className="productClass">
                            <SelectDiv  
                            noIcon={true}
                            style={{width:'29.33vw',marginRight:'12px'}}
                            model={this.state.dateValue} 
                            data={this.state.DateArray} 
                            changeType={this.changeType.bind(this)}
                            />
                            <SelectDiv  style={{flex:1}}
                                
                                showIcon={false}
                                title={this.state.timeText}
                                type='text'
                                topDivClick={this.openTime.bind(this)}
                            />
                    </div>
                    <div className="types" style={{textAlign:'center',margin:'5.33vw 0px'}}>
                        <Buttons style={{}} data={btns} defaultValue="num" activeBack={this.btnBack.bind(this)}/>
                    </div>
                </div>
                <div className="tableWrap">
                    <MyTable>
                        <MyTableHead>
                            <MyTableTh style={{width:'70px'}}>{"排名"}</MyTableTh>
                            <MyTableTh>{"耗材名称"}</MyTableTh>
                            {/* <MyTableTh style={{width:'70px'}}>{"销量"}</MyTableTh> */}
                            {<MyTableTh style={{width:'70px'}}>{this.state.btnval=='num'?"销量":"销售额"}</MyTableTh>}
                            
                        </MyTableHead>
                        <MyTableBody>
                        {this.state.listData.map((s,index)=>{
                            return (
                                <MyTableTr>
                                    <MyTableTd>
                                        <span>{index+1}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.skuName}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{this.state.btnval=='num'?s.skuQuantity:s.skuMoney}</span>
                                    </MyTableTd>
                                </MyTableTr>
                            )
                        })}
                        </MyTableBody>
                    </MyTable>
                </div>
                <Calendar
                    visible={this.state.timeShow}
                    onCancel={this.onCanceltime.bind(this)}
                    onConfirm={(startDate,endDate)=>{this.onConfirm(startDate,endDate)}}
                    defaultDate={now}
                    
                />
            </div>
        )
    }
    componentDidMount(){
        function getScrollTop() {
            var scrollTop = 0;
            if(document.documentElement && document.documentElement.scrollTop) {
                scrollTop = document.documentElement.scrollTop;
            } else if(document.body) {
                scrollTop = document.body.scrollTop;
            }
            return scrollTop;
        }
        this.getCateList('');
        this.getProductsales();
        
    }
}

